<template>
  <div class="pricing-table-area about_us" id="pricing" :style="headerImgStyle">
    <div class="container">
      <div class="row title_message">
        <div class="col-lg-12">
          <div class="section-title-wrapper text-center mt-5">
            <h3 class="section-title font-width-light wow move-up white--text">
              Meet Team:
            </h3>
          </div>
        </div>
      </div>
      <div style="width: 200px; margin: 0 auto" v-if="loading">
        <v-progress-linear
          indeterminate
          rounded
          height="10"
          color="white"
        ></v-progress-linear>
      </div>
      <!-- pricing component -->
      <div class="row pricing-table-four" v-else>
        <div
          class="
            col-12 col-md-4 col-lg-4 col-xl-4
            pricing-table pricing-table--popular
            wow
            move-up
          "
          v-for="(item, ind) in items"
          :key="ind"
        >
          <div class="pricing-table__inner">
            <div class="pricing-table__top">
              <div class="pricing-table__header">
                <div class="pricing-table__image">
                  <img :src="item.img" class="img-fluid" alt="" />
                </div>
                <h4
                  class="pricing-table__title font_curve text-capitalize"
                  style="font-size: 1.5rem"
                >
                  {{ item.name }}
                </h4>
                <h2 class="pricing-table__title">{{ item.title }}</h2>
              </div>
              <div
                class="pricing-table__body text-center"
                style="font-size: 1rem"
                v-html="item.description"
              ></div>
            </div>
            <div class="pricing-table__footer">
              <a
                @click="openBrowserNewTab(item.link)"
                class="hover-style-link hover-style-link--green"
                >View profile<span class="btn-icon"
                  ><i class="far fa-long-arrow-right"></i>
                  <div></div></span
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GoogleSpreadsheet } from "google-spreadsheet";

export default {
  components: {},
  data() {
    return {
      loading: true,
      items: [],
    };
  },
  async created() {
    const doc = new GoogleSpreadsheet(
      "13cbeqQJRvAatognlZF2WKcJlAtjy2TuuZi7dZYY-wBE"
    );
    doc.useApiKey(process.env.VUE_APP_GCP_API_KEY);
    await doc.loadInfo();
    this.loadTeam(doc);
  },
  methods: {
    async loadTeam(doc) {
      this.loading = true;
      var sheet = doc.sheetsByIndex[2];
      var rows = await sheet.getRows();
      this.items = rows.map((r) => ({
        name: r.Name,
        title: r.Title,
        img: r.Image,
        description: r.Note,
        link: r.Url,
      }));
      this.loading = false;
    },
  },
};
</script>
